"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DMSIPCMethod;
(function (DMSIPCMethod) {
    DMSIPCMethod["ON_NODE_CONNECTED"] = "IPC_ON_NODE_CONNECTED";
    DMSIPCMethod["ON_NODE_DISCONNECTED"] = "IPC_ON_NODE_DISCONNECTED";
    DMSIPCMethod["ON_NUMBER_OF_CLIENTS_CHANGED"] = "IPC_ON_NUMBER_OF_CLIENTS_CHANGED";
    DMSIPCMethod["GET_CONNECTED_NODES"] = "IPC_GET_CONNECTED_NODES";
    DMSIPCMethod["SEND_NOTIFICATION_TO_APP_USERS"] = "IPC_SEND_NOTIFICATION_TO_APP_USERS";
    DMSIPCMethod["SEND_NOTIFICATION_TO_NODE"] = "SEND_NOTIFICATION_TO_NODE";
    DMSIPCMethod["EXECUTE_ON_WORKER"] = "IPC_EXECUTE_ON_WORKER";
    DMSIPCMethod["SUBSCRIBE_TO_EVENT"] = "SUBSCRIBE_TO_EVENT";
    DMSIPCMethod["GET_REVERSE_TUNNEL"] = "IPC_GET_REVERSE_TUNNEL";
    DMSIPCMethod["GET_WORKERS"] = "GET_WORKERS";
    DMSIPCMethod["LOG_FAILED_AUTH_ATTEMPT"] = "LOG_FAILED_AUTH_ATTEMPT";
    DMSIPCMethod["CLEAR_FAILED_AUTH_ATTEMPTS"] = "CLEAR_FAILED_AUTH_ATTEMPTS";
    DMSIPCMethod["GET_FAILED_ATTEMPTS"] = "GET_FAILED_ATTEMPTS";
    DMSIPCMethod["GET_ALL_FAILED_ATTEMPTS"] = "GET_ALL_FAILED_ATTEMPTS";
    DMSIPCMethod["BAN_IP"] = "BAN_IP";
    DMSIPCMethod["GET_IP_BAN_STATE"] = "GET_IP_BAN_STATE";
})(DMSIPCMethod || (DMSIPCMethod = {}));
exports.default = DMSIPCMethod;
//# sourceMappingURL=DMSIPCMethod.js.map